import { userConstants } from '../_constants/user.constants';

let user = JSON.parse(sessionStorage.getItem('crmUser'));
let admin = JSON.parse(sessionStorage.getItem('adminAccess'));
let currentPage = JSON.parse(sessionStorage.getItem('currentPage'));
let crmUser = user ? user : {};
const initialState = { loggedIn: true, adminAccess: admin ? admin : false, crmUser, currentPage };

export function authentication(state = initialState, action) {
    if (action && action.crmUser) {
        // add company number to crmUser object
        if (action.crmUser.BusinessUnitReference && action.crmUser.BusinessUnitReference.CompanyNumber) {
            action.crmUser.companyNumber = action.crmUser.BusinessUnitReference.CompanyNumber;
        }
    }
    if (state && state.crmUser) {
        // add company number to crmUser object
        if (state.crmUser.BusinessUnitReference && state.crmUser.BusinessUnitReference.CompanyNumber) {
            state.crmUser.companyNumber = state.crmUser.BusinessUnitReference.CompanyNumber;
        }
    }
    switch (action.type) {
        case userConstants.LOGIN_SUCCESS:
            return {
                loggedIn: true,
                crmUser: action.crmUser,
                adminAccess: action.adminAccess,
                currentPage: action.currentPage
            };
        case userConstants.IMPERSONATE:
            return {
                loggedIn: true,
                crmUser: action.crmUser,
                adminAccess: true
            };
        case userConstants.LOGIN_FAILURE:
            return {
                currentPage: 'Login'
            };
        case userConstants.LOGOUT:
            return {
                currentPage: 'Login'
            };
        case userConstants.CHANGE_PAGE:
            return {
                loggedIn: true,
                currentPage: action.pageName,
                adminAccess: action.adminAccess,
                crmUser: action.crmUser
            };
        default:
            return state;
    }
}